import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ProjectType, ProjectTypesType } from "../../../types/ScientificModule";

const initialState: ProjectTypesType = {
    description: ""
};

const projectTypesSlice = createSlice({
    name: "projectTypes",
    initialState,
    reducers: {
        setProjectTypesData: (state, action: PayloadAction<ProjectTypesType>) => ({
            ...state,
            ...action.payload,
        }),
        resetProjectTypesData: () => ({ ...initialState }),
    },
});

export const { setProjectTypesData, resetProjectTypesData } =
    projectTypesSlice.actions;

export default projectTypesSlice.reducer;
